export default __webpack_public_path__ + "static/media/explorer_welcome_grafik2.fc51fae2.gif";